import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-buttons-helping-toughts',
  templateUrl: './buttons-helping-toughts.component.html',
  styleUrls: ['./buttons-helping-toughts.component.less']
})
export class ButtonsHelpingToughtsComponent implements OnInit, OnDestroy {
  @Output() helpingClicked = new EventEmitter<boolean>();
  @Output() notHelpingClicked = new EventEmitter<boolean>();
  @Input() disabled: boolean = false;
  @Input() disableHelping: boolean = false;
  @Input() disableNotHelping: boolean = false;
  constructor(private elementRef: ElementRef<SVGElement>) {

  }
  ngOnDestroy(): void {
    this.elementRef.nativeElement.querySelector('[data-name="button_niet_helpend"]')?.removeEventListener('click', this.click_not_helping.bind(this))
    this.elementRef.nativeElement.querySelector('[data-name="button_helpend"]')?.removeEventListener('click', this.click_helping.bind(this));
  }

  ngOnInit(): void {
    this.elementRef.nativeElement.querySelector('[data-name="button_niet_helpend"]')?.addEventListener('click', this.click_not_helping.bind(this))
    this.elementRef.nativeElement.querySelector('[data-name="button_helpend"]')?.addEventListener('click', this.click_helping.bind(this));
  }
  click_not_helping() {
    this.notHelpingClicked.emit(true);

  }
  click_helping() {
    this.helpingClicked.emit(true);
  }

}
